<template>
  <div v-if="selectedIntegration" class="">
    <div class="flex justify-start items-center gap-2 w-full p-2">
      <v-btn @click="selectedIntegration = null" icon :color="$vuetify.theme.currentTheme.primary">
        <v-icon> mdi-arrow-left </v-icon>
      </v-btn>
      <span class="gradient-label font-semibold text-md text-gray-700">
        {{ selectedIntegration.label }} Configuration
      </span>
    </div>
    <component
      :is="selectedIntegration.component"
      :receivedData="receivedData"
      @refetchData="$emit('refetchData')"
    />
  </div>
  <div v-else class="grid grid-cols-2 gap-4 w-full p-2">
    <div
      v-for="(platform, index) in platformIntegrations"
      :key="index"
      class="flex flex-wrap justify-between items-center border rounded-md p-2"
    >
      <div class="flex items-center gap-4">
        <v-icon v-if="platform.useIcon" size="32" :color="$vuetify.theme.currentTheme.primary">{{
          platform.icon
        }}</v-icon>
        <img v-else :src="platform.icon" class="w-8" />
        <span class="font-semibold text-md text-gray-700">{{ platform.label }}</span>
      </div>
      <div class="flex items-center justify-end gap-2">
        <v-switch
          v-model="platform.enabled"
          @change="platformSwitch(platform)"
          :ripple="false"
          inset
          dense
          :label="platform.enabled ? 'Enable' : 'Disable'"
        ></v-switch>

        <!-- Hide Configure button if enabled is false or no component is present -->

        <v-icon
          :color="$vuetify.theme.currentTheme.primary"
          @click="selectedIntegration = platform"
          v-if="platform.enabled && platform.component"
          >mdi-cog</v-icon
        >
      </div>
    </div>
  </div>
</template>

<script>
import WhatsappIntegration from './WhatsappIntegration.vue'
import TelecallerIntegration from './TeleCallerIntegration.vue'
import WebhookIntegration from './WebhookIntegration.vue'
import RazorPayIntegration from './RazorPayIntegration.vue'
import AwsMailIntegration from './AwsMailIntegration.vue'
import QuickberrySmsIntegration from './QuickberrySmsIntegration.vue'
import MailForwardingIntegration from './MailForwardingIntegration.vue'
import ImgWhatsapp from '@/assets/img/whatsapp.png'
import ImgTelecaller from '@/assets/img/phone.png'
import ImgRazorpay from '@/assets/img/razor_pay_icon.png'
import ImgAwsMail from '@/assets/img/aws_logo.png'
import ImgWebohook from '@/assets/img/webhook.png'
import ImgSms from '@/assets/img/sms_icon.png'
import { isModuleFeatureAllowed } from '@/utils/common'

export default {
  name: 'WhatsappComponent',
  components: {
    WhatsappIntegration,
    TelecallerIntegration,
    WebhookIntegration,
    RazorPayIntegration,
    AwsMailIntegration,
    QuickberrySmsIntegration,
    MailForwardingIntegration
  },
  data() {
    return {
      selectedIntegration: null
    }
  },
  props: {
    receivedData: {
      type: Object,
      default: null
    }
  },
  computed: {
    platformIntegrations() {
      const platforms = [
        {
          name: 'whatsappIntegration',
          label: 'Whatsapp',
          component: 'WhatsappIntegration',
          icon: ImgWhatsapp,
          enabled: true,
          moduleName: 'WHATS_APP_BOT'
        },
        {
          name: 'telecallerIntegration',
          label: 'Telecaller',
          component: 'TelecallerIntegration',
          icon: ImgTelecaller,
          enabled: true,
          moduleName: 'CALL_A_CUSTOMER'
        },
        // {
        //   name: 'webhookIntegration',
        //   label: 'Webhook',
        //   component: 'WebhookIntegration',
        //   icon: ImgWebohook,
        //   enabled: true,
        //   moduleName: 'CALL_A_CUSTOMER'
        // },
        // {
        //   name: 'razorPayIntegration',
        //   label: 'RazorPay',
        //   component: 'RazorPayIntegration',
        //   icon: ImgRazorpay,
        //   enabled: true,
        //   moduleName: 'CALL_A_CUSTOMER'
        // },
        {
          name: 'awsMailIntegration',
          label: 'AWS Mail',
          component: 'AwsMailIntegration',
          icon: ImgAwsMail,
          enabled: !!this.receivedData?.applications?.awsMail?.enable,
          moduleName: 'CALL_A_CUSTOMER'
        },
        {
          name: 'quickberrySmsIntegration',
          label: 'Quickberry SMS',
          component: 'QuickberrySmsIntegration',
          icon: ImgSms,
          enabled: !!this.receivedData?.applications?.quickberrySms?.enable,
          moduleName: 'CALL_A_CUSTOMER'
        },
        {
          name: 'mailForwardingIntegration',
          label: 'Mail Forwarding',
          component: 'MailForwardingIntegration',
          icon: 'mdi-email-outline',
          useIcon: true,
          enabled: !!this.receivedData?.applications?.mailForwarding?.enable,
          moduleName: 'CALL_A_CUSTOMER'
        }
      ]

      return platforms.filter((platform) => this.isFeatureVisible(platform.moduleName))
    }
  },
  methods: {
    isFeatureVisible(feature) {
      return isModuleFeatureAllowed('ADDONS', feature)
    },
    async platformSwitch(platform) {
      if (platform.name === 'awsMailIntegration') {
        try {
          const payload = {
            applications: {
              ...this.receivedData?.applications,
              awsMail: {
                ...this.receivedData?.applications?.awsMail,
                enable: platform.enabled
              }
            }
          }
          await this.$axios.post('/org/config', payload)
          this.$emit('refetchData')
          this.$toast.success(
            `${platform.label} ${platform.enabled ? 'Enabled' : 'Disabled'} Successfully`
          )
        } catch (error) {
          console.error(error)
          this.$toast.error(`Failed to update ${platform.label} status`)
          platform.enabled = !platform.enabled
        }
      } else if (platform.name === 'quickberrySmsIntegration') {
        try {
          const payload = {
            applications: {
              ...this.receivedData?.applications,
              quickberrySms: {
                ...this.receivedData?.applications?.quickberrySms,
                enable: platform.enabled
              }
            }
          }
          await this.$axios.post('/org/config', payload)
          this.$emit('refetchData')
          this.$toast.success(
            `${platform.label} ${platform.enabled ? 'Enabled' : 'Disabled'} Successfully`
          )
        } catch (error) {
          console.error(error)
          this.$toast.error(`Failed to update ${platform.label} status`)
          platform.enabled = !platform.enabled
        }
      } else if (platform.name === 'mailForwardingIntegration') {
        try {
          const payload = {
            applications: {
              ...this.receivedData?.applications,
              mailForwarding: {
                ...this.receivedData?.applications?.mailForwarding,
                enable: platform.enabled
              }
            }
          }
          await this.$axios.post('/org/config', payload)
          this.$emit('refetchData')
          this.$toast.success(
            `${platform.label} ${platform.enabled ? 'Enabled' : 'Disabled'} Successfully`
          )
        } catch (error) {
          console.error(error)
          this.$toast.error(`Failed to update ${platform.label} status`)
          platform.enabled = !platform.enabled
        }
      }
    }
  }
}
</script>

<style>
.gradient-label {
  display: inline-block;
  background-image: linear-gradient(135deg, #1e3c72, #2a5298);
  -webkit-background-clip: text;
  color: transparent;
}
</style>
